import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { DashboardEntity } from './dashboard.entity';
import { ReportsRegistryEntity } from './reports-registry.entity';
import { WidgetFilterEntity } from './widget-filter.entity';

@Index('idx_dashboard', ['fkDashboardId'], {})
@Index('idx_position', ['fkDashboardId', 'positionX', 'positionY'], {})
@Index('idx_reports_registry', ['fkReportsRegistryId'], {})
@Index('idx_visible', ['isVisible'], {})
@Entity('dashboard_widget')
export class DashboardWidgetEntity extends BaseEntity {
	@Column('int', { name: '_fk__dashboard__id', unsigned: true })
	public fkDashboardId!: number;

	@Column('int', { name: '_fk__reports_registry__id', unsigned: true })
	public fkReportsRegistryId!: number;

	@Column('varchar', { name: 'title', length: 255 })
	public title!: string;

	@Column('int', {
		name: 'positionX',
		nullable: true,
		unsigned: true,
		default: () => "'0'",
	})
	public positionX!: number | null;

	@Column('int', {
		name: 'positionY',
		nullable: true,
		unsigned: true,
		default: () => "'0'",
	})
	public positionY!: number | null;

	@Column('int', {
		name: 'width',
		nullable: true,
		unsigned: true,
		default: () => "'1'",
	})
	public width!: number | null;

	@Column('int', {
		name: 'height',
		nullable: true,
		unsigned: true,
		default: () => "'1'",
	})
	public height!: number | null;

	@Column('json', { name: 'widgetConfig', nullable: true })
	public widgetConfig!: object | null;

	@Column('int', {
		name: 'sortOrder',
		nullable: true,
		unsigned: true,
		default: () => "'0'",
	})
	public sortOrder!: number | null;

	@Column({
		type: 'boolean',
		name: 'isVisible',
		nullable: true,
		width: 1,
		default: () => "'1'",
	})
	public isVisible!: boolean | null;

	@ManyToOne(() => DashboardEntity, (dashboard) => dashboard.dashboardWidgets, {
		onDelete: 'CASCADE',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__dashboard__id', referencedColumnName: 'id' }])
	public fkDashboard!: DashboardEntity;

	@ManyToOne(
		() => ReportsRegistryEntity,
		(reportsRegistry) => reportsRegistry.dashboardWidgets,
		{ onDelete: 'RESTRICT', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__reports_registry__id', referencedColumnName: 'id' },
	])
	public fkReportsRegistry!: ReportsRegistryEntity;

	@OneToMany(
		() => WidgetFilterEntity,
		(widgetFilter) => widgetFilter.fkDashboardWidget,
		{},
	)
	public widgetFilters!: Array<WidgetFilterEntity>;
}
